import { Box, Flex } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { Stars03 } from '@kula-ai/icons-core';

interface ScorecardPDFSummaryProps {
  summary?: string | null;
}

/** Convert a limited subset of markdown (bold, italic) to safe HTML. */
const parseMarkdownToHtml = (text: string): string => {
  const escaped = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  return escaped
    .replace(/\*\*(.+?)\*\*/gs, '<strong>$1</strong>')
    .replace(/\*(.+?)\*/gs, '<em>$1</em>');
};

export const ScorecardPDFSummary = ({ summary }: ScorecardPDFSummaryProps) => {
  if (!summary) {
    return null;
  }

  return (
    <Flex flexDir="column" gap="18px" mb="24px">
      <Flex alignItems="center" gap="12px">
        <Flex
          alignItems="center"
          gap="6px"
          px="6px"
          py="4px"
          borderRadius="6px"
          bg="secondary-50"
        >
          <Stars03
            strokeWidth="1.2"
            size={16}
            gradient={{
              direction: 'vertical',
              colors: [
                { offset: '0%', color: '#8A90FF' },
                { offset: '100%', color: '#B15FDA' },
              ],
            }}
          />

          <KText
            as="span"
            size="sm-medium"
            bg="linear-gradient(180deg, #8A90FF 0%, #B15FDA 100%)"
            bgClip="text"
            color="transparent"
          >
            AI summary
          </KText>
        </Flex>
        <Box
          borderBottom="1px solid"
          borderColor={'border-color'}
          flex={1}
        ></Box>{' '}
      </Flex>
      <Box
        dangerouslySetInnerHTML={{ __html: parseMarkdownToHtml(summary) }}
        fontSize="14px"
        fontWeight="400"
        color="var(--kula-colors-secondary-700)"
        lineHeight="160%"
        whiteSpace="pre-wrap"
        wordBreak="break-word"
        sx={{
          strong: {
            fontWeight: '650',
            color: 'var(--kula-colors-secondary-900)',
          },
          em: { fontStyle: 'italic' },
        }}
      />
    </Flex>
  );
};
